export default {
  SET_USER: 'SET_USER',
  CLEAR_USER: 'CLEAR_USER',
};



// WEBPACK FOOTER //
// ./src/reducers/user/types.js